import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useSWRImmutable from 'swr/immutable';

import { TopSpotGame } from '@/api/cms';
import { fetcherCMS } from '@/modules/api';
import { createCMSQuery, getCMSLocale } from '@/modules/cms';
import { useCommonStore } from '@/store';

export const useCMSTopSpotGame = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const user = useCommonStore.use.user();

  const query = useMemo(() => {
    return createCMSQuery({
      ...getCMSLocale(language),
    });
  }, [language]);

  const swrKey = user?.id ? `/top-spot-game?${query}` : null;

  const {
    data = null,
    error,
    isLoading,
  } = useSWRImmutable<TopSpotGame>(swrKey, fetcherCMS);

  return {
    topSpotCMSData: data,
    error,
    isLoading,
  };
};
